<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                style="width: 180px"
                v-model="queryForm.qstr"
                placeholder="編號、班名、名稱、序號、備註"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ myownOrg }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="members"
            @sort-change="sortChange"
            :default-sort="{ prop: 'id', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="人員編號"
              prop="no"
              sortable="custom"
              width="110"
            >
            </el-table-column>
            <el-table-column
              label="班級名稱"
              prop="className"
              sortable="custom"
              width="110"
            >
            </el-table-column>
            <el-table-column
              label="月光機序號"
              prop="moonlight2SerialNumber"
              sortable="custom"
              width="200"
            >
            </el-table-column>
            <el-table-column
              label="人員名稱"
              prop="name"
              sortable="custom"
              width="110"
            >
            </el-table-column>

            <el-table-column
              label="備註"
              prop="memo"
              sortable="custom"
              width="160"
            >
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="auditMbr(scope.row)"
                  >檢查
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <OrgAuditDlg
          v-model="isDlgVisible"
          :mbrId="dlgItemId"
          :mbrName="dlgItemName"
          @startAudit="handleStartAudit"
          :key="dlgKey"
        ></OrgAuditDlg>

        <OrgAuditAssetListDlg
          v-model="isStartAuditDlgVisible"
          :mbrId="dlgItemId"
          :mbrName="dlgItemName"
          :chnlIds="auditChnlIds"
          @stopAudit="handleStopAudit"
          :key="`startAudit_${startAuditDlgKey}`"
        ></OrgAuditAssetListDlg>

      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SYS_ORG_NAME } from "@/appConfig";
import OrgAuditDlg from "@/components/org/OrgAuditDlg";
import OrgAuditAssetListDlg from "@/components/org/OrgAuditAssetListDlg";
export default {
  name: "member",
  components: {
    OrgAuditDlg,
    OrgAuditAssetListDlg,
  },
  created() {
    this.$store.dispatch("member/list", {
      max: this.pageSize,
      offset: this.offset,
      sort: this.sort,
      order: this.order,
    });
  },
  data() {
    return {
      dlgItemId: null,
      dlgItemName: "",
      auditChnlIds: [],
      dlgKey: 0,
      startAuditDlgKey: 0,
      importDlgKey: 0,
      isDlgVisible: false,
      isStartAuditDlgVisible: false,
      isImportDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
    };
  },
  methods: {
    handleStartAudit (mbrId, mbrName, chnlIds) {
      //console.log(`handleStartAudit: chnlIds = ${JSON.stringify(chnlIds)}`);
      this.auditChnlIds = chnlIds;
      this.dlgItemId = mbrId;
      this.dlgItemName = mbrName;
      this.startAuditDlgKey = this.startAuditDlgKey ? 0 : 1;
      this.isStartAuditDlgVisible = true;
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.query(this.pageSize, 0, this.sort, this.order, queryForm);
    },
    auditMbr(mbr) {
      this.dlgItemId = mbr.id;
      this.dlgItemName = mbr.name;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    handleStopAudit(mbrId, mbrName) {
      this.dlgItemId = mbrId;
      this.dlgItemName = mbrName;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.queryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.queryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("member/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    deleteMember(id) {
      this.$confirm("此操作將永久刪除該單位人員, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("member/remove", id).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.queryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("member/SET_SORT", "id");
        this.$store.commit("member/SET_ORDER", "ascending");
      } else {
        this.$store.commit("member/SET_SORT", args.prop);
        this.$store.commit("member/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.queryForm
      );
    },
  },
  computed: {
    isMyownOrgSys() {
      return this.myownOrg === SYS_ORG_NAME;
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      members: "member/members",
      total: "member/total",
      offset: "member/offset",
      sort: "member/sort",
      order: "member/order",
    }),
  },
};
</script>

<style></style>
